import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const PlayerVersusPlayer: React.FC = () => {
    return (
        <Layout>
            <div>
                <p><Link to="/">top</Link></p>
                PVP
            </div>
        </Layout >
    );
}

export default PlayerVersusPlayer;
